const BASE_URL = import.meta.env.VITE_API_URL

async function apiFetch(endpoint, options = {}) {
    const url = BASE_URL + endpoint;
    const token = localStorage.getItem('token');
    const headers = { ...options.headers };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await fetch(url, { ...options, headers });
    if (response.status === 401) {
        localStorage.removeItem('logeado');
        localStorage.removeItem('token');
        window.location.reload();
        throw new Error('Sesión expirada');
    }
    if (!response.ok) {
        throw new Error(`API call failed: ${response.status}`);
    }
    return response.json();
}

export default apiFetch;
